<template>
    <div class="doughnut-chart-container">
        <svg width="400" height="400" viewBox="0 0 400 400" class="doughnut-chart">
            <circle
                cx="200"
                cy="200"
                r="150"
                fill="none"
                stroke="#f0f0f0"
                stroke-width="80"
            />
            <g v-for="(item, index) in computedData" :key="index">
                <circle
                    :r="radius"
                    :cx="center"
                    :cy="center"
                    fill="transparent"
                    :stroke="getColorForIndex(index)"
                    stroke-width="80"
                    :stroke-dasharray="getDashArray(item)"
                    :stroke-dashoffset="getDashOffset(index)"
                    class="doughnut-segment"
                    stroke-linecap="butt"
                />
                <text
                    :x="getLabelPosition(index).x"
                    :y="getLabelPosition(index).y"
                    text-anchor="middle"
                    dominant-baseline="middle"
                    class="doughnut-label"
                    :style="{ fill: getFontColorForIndex(index) }"
                >
                    {{ item.percentage }}%
                </text>
            </g>
        </svg>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed: {
        computedData() {
            const transformed = Object.entries(this.data).map(([label, value]) => ({
                label,
                value
            }));
            const totalValue = transformed.reduce((sum, item) => sum + item.value, 0);

            return transformed.map(item => ({
                ...item,
                percentage: ((item.value / totalValue) * 100).toFixed(1),
            }));
        },
        totalValue() {
            return this.computedData.reduce((sum, item) => sum + item.value, 0);
        },
        center() {
            return 200;
        },
        radius() {
            return 150;
        }
    },
    methods: {
        getDashArray(item) {
            const circumference = 2 * Math.PI * this.radius;
            const segmentLength = (item.value / this.totalValue) * circumference;
            return `${segmentLength} ${circumference - segmentLength + 0.5}`;
        },
        getDashOffset(index) {
            const circumference = 2 * Math.PI * this.radius;
            const offset = this.computedData
                .slice(0, index)
                .reduce((acc, item) => acc + (item.value / this.totalValue) * circumference, 0);
            return -offset;
        },
        getLabelPosition(index) {
            const midAngle = this.getMidAngle(index);
            const labelRadius = this.radius; // 숫자를 도넛 위에 올리기 위해 반지름을 조정
            return {
                x: this.center + labelRadius * Math.cos(midAngle),
                y: this.center + labelRadius * Math.sin(midAngle)
            };
        },
        getMidAngle(index) {
            const startAngle = this.computedData
                .slice(0, index)
                .reduce((acc, item) => acc + (item.value / this.totalValue) * 2 * Math.PI, 0);
            const sliceAngle = (this.computedData[index].value / this.totalValue) * 2 * Math.PI;
            return startAngle + sliceAngle / 2;
        },
        getColorForIndex(index) {
            if (index === 0) {
                return '#1626B6'; // 첫 번째 항목의 배경색
            } else if (index === 1) {
                return '#e8ebed'; // 두 번째 항목의 배경색
            }
            const colors = ['#ff9999', '#66b3ff', '#99ff99', '#ffcc99', '#c2c2f0'];
            return colors[index % colors.length];
        },
        getFontColorForIndex(index) {
            if (index === 0) {
                return 'white'; // 첫 번째 항목의 글씨 색상
            } else if (index === 1) {
                return 'black'; // 두 번째 항목의 글씨 색상
            }
            return '#000'; // 나머지 항목의 기본 글씨 색상
        }
    }
};
</script>

<style scoped>
.doughnut-chart-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
}

.doughnut-chart {
    transform: rotate(0deg); /* 시작점을 위쪽으로 설정 */
}

.doughnut-segment {
    transition: stroke-dasharray 0.3s ease, stroke-dashoffset 0.3s ease;
}

.doughnut-label {
    font-size: 16px;
    fill: #000;
    font-weight: normal;
}
</style>
